var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-item", attrs: { id: _vm.id } }, [
    _c(
      "button",
      {
        staticClass: "trigger",
        class: { active: _vm.active },
        attrs: {
          type: "button",
          "aria-expanded": _vm.active,
          "aria-controls": _vm.dropdownId,
        },
        on: { click: _vm.handleClick },
      },
      [
        _c("div", { staticClass: "content" }, [
          _c("span", { staticClass: "label" }, [_vm._v(_vm._s(_vm.label))]),
          _vm._v(" "),
          _c("span", { staticClass: "display-value" }, [
            _vm._v(_vm._s(_vm.displayValue || _vm.fallbackDisplayValue)),
          ]),
        ]),
        _vm._v(" "),
        _c("i", { staticClass: "sd2-icons arrow-down" }),
      ]
    ),
    _vm._v(" "),
    _vm.active
      ? _c("div", {
          staticClass: "overlay",
          on: { click: _vm.handleOverlayClick },
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.active
      ? _c("div", { staticClass: "dropdown", attrs: { id: _vm.dropdownId } }, [
          _c("div", { staticClass: "dropdown-header" }, [
            _c("h2", { staticClass: "dropdown-title" }, [
              _vm._v(_vm._s(_vm.drawerConfig.title)),
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "dropdown-close",
                on: { click: _vm.handleCloseClick },
              },
              [
                _vm.drawerConfig.closeText
                  ? [_vm._v(_vm._s(_vm.drawerConfig.closeText))]
                  : _c("i", { staticClass: "sd2-icons cross" }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dropdown-content" },
            [_vm._t("default")],
            2
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }